export type UploadingFile = {
  fileKey: string
  fileName: string
  fileMimeType: string
}

// Singleton: tracks all in-progress files across upload types (filepool + RLCP)
// and drives UI subscription via pub/sub pattern.
const loadingFiles = new Map<string, UploadingFile>()
const listeners = new Set<() => void>()

function notifyListeners(): void {
  listeners.forEach((listener) => listener())
}

/**
 * Subscribes to loading files state changes. The listener is called whenever
 * a file is added or removed from the loading state.
 *
 * @returns Unsubscribe function — call it to stop receiving notifications (e.g. on component unmount)
 */
export function subscribeToLoadingFiles(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getLoadingFiles(): UploadingFile[] {
  return Array.from(loadingFiles.values())
}

export function addLoadingFile(fileKey: string, fileName: string, fileMimeType: string): void {
  loadingFiles.set(fileKey, { fileKey, fileName, fileMimeType })
  notifyListeners()
}

export function removeLoadingFile(fileKey: string): void {
  loadingFiles.delete(fileKey)
  notifyListeners()
}
